import React from "react";

const sections = [
  {
    title: "Information We Collect",
    points: [
      "We may collect personal details such as your name, phone number, email address, payment information, and device-related information when you use the application.",
      "We may also collect usage data such as IP address, browser details, device identifiers, and activity logs to improve performance and maintain security.",
    ],
  },
  {
    title: "How We Use Information",
    points: [
      "To create and manage user accounts, process requests, and provide application features.",
      "To send important updates, support replies, service notices, and security-related communication.",
      "To monitor usage, prevent misuse, improve the platform, and maintain operational safety.",
    ],
  },
  {
    title: "Sharing of Information",
    points: [
      "Information may be shared with service providers, payment partners, affiliates, or legal authorities where required for service delivery, compliance, or security.",
      "We do not sell personal information to third parties.",
    ],
  },
  {
    title: "Data Retention",
    points: [
      "Personal and transaction-related information is retained only for as long as necessary for operational, legal, support, and security purposes.",
      "Some information may be retained longer if required to comply with legal or regulatory obligations.",
    ],
  },
  {
    title: "Security",
    points: [
      "We use reasonable administrative and technical safeguards to protect your data.",
      "No online transmission or storage method is fully secure, so users should also protect their account credentials.",
    ],
  },
  {
    title: "Your Rights",
    points: [
      "You may request access to, correction of, or deletion of your personal information where applicable.",
      "You may contact us if you have questions about how your data is handled.",
    ],
  },
  {
    title: "Policy Changes",
    points: [
      "This privacy policy may be updated from time to time. Any changes will be reflected on this page with an updated effective date.",
    ],
  },
];

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-5xl">
        <div className="rounded-3xl bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-500 px-6 py-8 text-white shadow-xl md:px-10">
          <p className="text-sm font-medium uppercase tracking-[0.3em] text-blue-100">
            Legal Page
          </p>
          <h1 className="mt-3 text-3xl font-bold md:text-4xl">Privacy Policy</h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-blue-50 md:text-base">
            This page explains how information is collected, used, protected, and retained while users interact with the application and related services.
          </p>
          <p className="mt-4 text-sm font-medium text-blue-100">
            Last updated: January 29, 2025
          </p>
        </div>

        <div className="mt-8 rounded-3xl bg-white p-6 shadow-lg md:p-10">
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-slate-900">Overview</h2>
              <p className="mt-3 text-sm leading-7 text-slate-600 md:text-base">
                We value user privacy and are committed to protecting personal information. By using this application, users agree to the collection and use of information as described in this privacy policy.
              </p>
            </section>

            {sections.map((section) => (
              <section key={section.title} className="border-t border-slate-100 pt-6">
                <h3 className="text-xl font-semibold text-slate-900">{section.title}</h3>
                <div className="mt-4 space-y-3">
                  {section.points.map((point) => (
                    <p key={point} className="text-sm leading-7 text-slate-600 md:text-base">
                      {point}
                    </p>
                  ))}
                </div>
              </section>
            ))}

            <section className="border-t border-slate-100 pt-6">
              <h3 className="text-xl font-semibold text-slate-900">Contact Us</h3>
              <p className="mt-3 text-sm leading-7 text-slate-600 md:text-base">
                If you have questions about this privacy policy, contact us at{" "}
                <a
                  href="mailto:h@gmail.com"
                  className="font-medium text-indigo-600 hover:text-indigo-700"
                >
                  h@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
